
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emporium/planet/list",
      function () {
        return require("private-next-pages/emporium/planet/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emporium/planet/list"])
      });
    }
  